import React, { useState } from "react";


export default function CreditApplicationForm() {
  const [formData, setFormData] = useState({});

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
  };

  return (
    <div className="container my-5">
      <h2 className="text-center mb-4">Credit Application Form</h2>
      <form onSubmit={handleSubmit}>
        {/* Company Details */}
        <div className="card mb-4">
          <div className="card-header bg-primary text-white">
            Company Information
          </div>
          <div className="card-body">
            <div className="row mb-3">
              <div className="col-md-6">
                <label className="form-label">Company Name</label>
                <input
                  type="text"
                  className="form-control"
                  name="companyName"
                  onChange={handleChange}
                />
              </div>
              <div className="col-md-6">
                <label className="form-label">Address</label>
                <input
                  type="text"
                  className="form-control"
                  name="address"
                  onChange={handleChange}
                />
              </div>
            </div>

            <div className="row mb-3">
              <div className="col-md-3">
                <label className="form-label">Telephone Office</label>
                <input
                  type="text"
                  className="form-control"
                  name="telephone"
                  onChange={handleChange}
                />
              </div>
              <div className="col-md-3">
                <label className="form-label">Fax No.</label>
                <input
                  type="text"
                  className="form-control"
                  name="fax"
                  onChange={handleChange}
                />
              </div>
              <div className="col-md-3">
                <label className="form-label">Mobile</label>
                <input
                  type="text"
                  className="form-control"
                  name="mobile"
                  onChange={handleChange}
                />
              </div>
              <div className="col-md-3">
                <label className="form-label">Email</label>
                <input
                  type="email"
                  className="form-control"
                  name="email"
                  onChange={handleChange}
                />
              </div>
            </div>

            <div className="row mb-3">
              <div className="col-md-6">
                <label className="form-label">Date Established</label>
                <input
                  type="date"
                  className="form-control"
                  name="dateEstablished"
                  onChange={handleChange}
                />
              </div>
              <div className="col-md-6">
                <label className="form-label">Annual Turnover (AED)</label>
                <input
                  type="number"
                  className="form-control"
                  name="turnover"
                  onChange={handleChange}
                />
              </div>
            </div>

            <div className="mb-3">
              <label className="form-label">Business Type</label>
              <select
                className="form-select"
                name="businessType"
                onChange={handleChange}
              >
                <option>Corporate</option>
                <option>Partnership</option>
                <option>Sole Proprietorship</option>
              </select>
            </div>
          </div>
        </div>

        {/* Owner/Partner Info */}
        <div className="card mb-4">
          <div className="card-header bg-secondary text-white">
            Owner / Partner Information
          </div>
          <div className="card-body">
            <div className="row mb-3">
              <div className="col-md-3">
                <label className="form-label">Name</label>
                <input
                  type="text"
                  className="form-control"
                  name="ownerName"
                  onChange={handleChange}
                />
              </div>
              <div className="col-md-3">
                <label className="form-label">Designation</label>
                <input
                  type="text"
                  className="form-control"
                  name="designation"
                  onChange={handleChange}
                />
              </div>
              <div className="col-md-3">
                <label className="form-label">Nationality</label>
                <input
                  type="text"
                  className="form-control"
                  name="nationality"
                  onChange={handleChange}
                />
              </div>
              <div className="col-md-3">
                <label className="form-label">EID No.</label>
                <input
                  type="text"
                  className="form-control"
                  name="eidNo"
                  onChange={handleChange}
                />
              </div>
            </div>
          </div>
        </div>

        {/* Bank Details */}
        <div className="card mb-4">
          <div className="card-header bg-info text-white">Bank Details</div>
          <div className="card-body">
            <div className="row mb-3">
              <div className="col-md-6">
                <label className="form-label">Bank Name</label>
                <input
                  type="text"
                  className="form-control"
                  name="bankName"
                  onChange={handleChange}
                />
              </div>
              <div className="col-md-6">
                <label className="form-label">Account No.</label>
                <input
                  type="text"
                  className="form-control"
                  name="accountNo"
                  onChange={handleChange}
                />
              </div>
            </div>

            <div className="mb-3">
              <label className="form-label">Address</label>
              <input
                type="text"
                className="form-control"
                name="bankAddress"
                onChange={handleChange}
              />
            </div>

            <div className="mb-3">
              <label className="form-label">Contact Person (Finance Dept.)</label>
              <input
                type="text"
                className="form-control"
                name="financeContact"
                onChange={handleChange}
              />
            </div>
          </div>
        </div>

        {/* Credit Required */}
        <div className="card mb-4">
          <div className="card-header bg-warning">Credit Required</div>
          <div className="card-body">
            <div className="row mb-3">
              <div className="col-md-6">
                <label className="form-label">Credit Required (AED)</label>
                <input
                  type="number"
                  className="form-control"
                  name="creditRequired"
                  onChange={handleChange}
                />
              </div>
              <div className="col-md-6">
                <label className="form-label">Credit Period (Days)</label>
                <input
                  type="number"
                  className="form-control"
                  name="creditPeriod"
                  onChange={handleChange}
                />
              </div>
            </div>

            <div className="mb-3">
              <label className="form-label">Type of Credit</label>
              <div className="d-flex flex-wrap">
                {["LPO", "Post Dated Cheque", "Units", "Parts", "Service", "Tyres & Batteries", "Others"].map(
                  (item) => (
                    <div className="form-check me-3" key={item}>
                      <input
                        type="checkbox"
                        className="form-check-input"
                        name="creditType"
                        value={item}
                        onChange={handleChange}
                      />
                      <label className="form-check-label">{item}</label>
                    </div>
                  )
                )}
              </div>
            </div>
          </div>
        </div>

        <button className="btn btn-primary w-100" type="submit">
          Submit Application
        </button>
      </form>
    </div>
  );
}
